export const baseIconSx = {
  transitionProperty: "width, fill",
};
